<button class="customHeaderLabel" type="button" (click)="emitHeader($event)" [ngClass]="{'disabled': isDisabled}" [disabled]="isDisabled" [attr.aria-label]="displayName" [attr.aria-expanded]="ariaExpanded">
  <span class="drill-down-btn" aria-hidden="true">+</span>
  <span title="{{displayName}}">{{displayName}}</span>
</button>
